import React, { Component } from "react";
import ICON from "../icons.js";

/* ============================================================================
 * HomeNavbar — แถบเมนูด้านบนของหน้าเว็บสาธารณะ
 * - ติดหัวจอ (sticky) และเพิ่มเงาเมื่อเลื่อนลง เพื่อแยกชั้นจากเนื้อหา
 * - เมนูเป็นการเลื่อนไปยัง section ในหน้าเดียวกัน ไม่ใช่เปลี่ยนหน้า
 *   ★ หน้าอื่นที่ไม่ใช่หน้ารวม (เช่น /room) ส่ง hideLinks มา — เมนูพวกนี้ชี้ไป section
 *     ที่ไม่มีอยู่ในหน้านั้น กดแล้วจะไม่เกิดอะไรขึ้น ทำให้คนกดคิดว่าเว็บค้าง
 * - โลโก้/ชื่อแบรนด์กดกลับหน้าแรกได้เสมอ (หน้ารวม = เลื่อนขึ้นบนสุด)
 * - จอเล็กยุบเป็นเมนูแบบพับ (burger)
 * ========================================================================== */
// กลับหน้ารวมต้องพาไปโครงการเดิมที่ผู้ใช้ดูอยู่ ไม่ใช่เด้งไปหน้ารวมทุกโครงการ
const getProjectQuery = () => {
    const params = new URLSearchParams(window.location.search);
    const project = params.get("project") || params.get("project_id") || "";
    return project ? `?project=${encodeURIComponent(project)}` : "";
};

const LINKS = [
    { key: "featured", href: "#hm-featured", label: "ห้องประกาศ" },
    { key: "projects", href: "#hm-projects", label: "โครงการ" },
    { key: "contact", href: "#hm-contact", label: "ติดต่อ" },
];

export default class HomeNavbar extends Component {
    state = { stuck: false, open: false, active: "featured" };

    componentDidMount() {
        window.addEventListener("scroll", this.onScroll, { passive: true });
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }

    onScroll = () => {
        const stuck = window.scrollY > 8;
        if (stuck !== this.state.stuck) this.setState({ stuck });
    };

    go = (event, item) => {
        event.preventDefault();
        this.setState({ active: item.key, open: false });
        const target = document.querySelector(item.href);
        // เผื่อ section นั้นไม่ได้แสดง (ผู้ดูแลยังไม่ได้ใส่เนื้อหา) — อย่าเด้งไปไหน
        if (target) window.scrollTo({ top: target.offsetTop - 90, behavior: "smooth" });
    };

    render() {
        const { stuck, open, active } = this.state;
        const { brand, logo, onContact, hideLinks } = this.props;

        // หน้าที่ไม่มี section ให้เลื่อน (เช่น /room) — โลโก้พาไปหน้ารวมแทน
        const homeHref = hideLinks
            ? `/overview${getProjectQuery()}`
            : "#hm-top";

        return (
            <header className={`hm-nav ${stuck ? "is-stuck" : ""}`} id="hm-top">
                <div className="hm-container">
                    <div className="hm-nav__inner">
                        <a
                            href={homeHref}
                            className="hm-nav__brand"
                            title="กลับหน้าแรก"
                            onClick={(e) => {
                                // อยู่หน้ารวมอยู่แล้ว = เลื่อนขึ้นบนสุดพอ ไม่ต้องโหลดหน้าใหม่
                                if (hideLinks) return;
                                e.preventDefault();
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                        >
                            {/* ตั้งโลโก้บริษัทไว้แล้วใช้โลโก้ ไม่งั้นใช้ไอคอนอาคารแทน */}
                            {logo ? (
                                <img src={logo} alt={brand || ""} style={{ height: 34, objectFit: "contain" }} />
                            ) : (
                                <span className="hm-ico" style={{ fontSize: 24 }}>{ICON.building}</span>
                            )}
                            <b style={{ marginLeft: 8 }}>{brand || "ห้องประกาศขาย/ให้เช่า"}</b>
                        </a>

                        <nav className="hm-nav__links">
                            {!hideLinks && LINKS.map((item) => (
                                <a
                                    key={item.key}
                                    href={item.href}
                                    className={`hm-nav__link ${active === item.key ? "is-active" : ""}`}
                                    onClick={(e) => this.go(e, item)}
                                >
                                    {item.label}
                                </a>
                            ))}
                        </nav>

                        <div className="hm-nav__right">
                            <button type="button" className="hm-btn hm-btn--primary hm-btn--sm hm-nav__cta" onClick={onContact}>
                                ฝากข้อมูลติดต่อกลับ
                            </button>
                            {!hideLinks && (
                            <button
                                type="button"
                                className="hm-nav__burger"
                                aria-label="menu"
                                aria-expanded={open}
                                onClick={() => this.setState({ open: !open })}
                            >
                                <span className="hm-ico">{open ? ICON.close : ICON.bars}</span>
                            </button>
                            )}
                        </div>
                    </div>

                    {/* เมนูสำหรับจอเล็ก */}
                    <div className={`hm-nav__mobile ${open ? "is-open" : ""}`}>
                        {!hideLinks && LINKS.map((item) => (
                            <a
                                key={item.key}
                                href={item.href}
                                className={`hm-nav__mobile-link ${active === item.key ? "is-active" : ""}`}
                                onClick={(e) => this.go(e, item)}
                            >
                                {item.label}
                                <span className="hm-ico">{ICON.chevron_right}</span>
                            </a>
                        ))}
                        <div className="hm-nav__mobile-actions">
                            <button type="button" className="hm-btn hm-btn--primary" onClick={onContact}>
                                <span className="hm-ico">{ICON.phone}</span>
                                ฝากข้อมูลติดต่อกลับ
                            </button>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}
